const quizApi = {
  SAVEEQUIZ: 'CSVPA-China/api/quiz/save', //添加测验
  UPDATEQUIZ: 'CSVPA-China/api/quiz/update', //编辑测验
  GETQUIZBYCLASSID: 'CSVPA-China/api/quiz/getByClassId', //测验
  DELETEQUIZ: 'CSVPA-China/api/quiz/delete' //删除测验
}

export default quizApi
